import { render, staticRenderFns } from "./fission.vue?vue&type=template&id=ed506f3c&scoped=true&"
import script from "./fission.vue?vue&type=script&lang=js&"
export * from "./fission.vue?vue&type=script&lang=js&"
import style0 from "./fission.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./fission.vue?vue&type=style&index=1&id=ed506f3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed506f3c",
  null
  
)

component.options.__file = "fission.vue"
export default component.exports